module.exports = __webpack_public_path__ + "img/BLANCO_Capacitación.84f5a99b.png";